// An unfinished review is kept in this browser, one per studio, so "Save draft"
// can pick up later.
const DRAFT_VERSION = 1;
const draftKey = (userId) => `productImportDraft:${userId}`;

export function loadDraft(userId) {
  if (!userId) return null;
  try {
    const draft = JSON.parse(localStorage.getItem(draftKey(userId)) || 'null');
    return draft?.version === DRAFT_VERSION && Array.isArray(draft.rows) ? draft : null;
  } catch {
    return null;
  }
}

// Throws when the browser won't keep it (private window, storage full).
export function storeDraft(userId, fields) {
  const draft = { version: DRAFT_VERSION, savedAt: new Date().toISOString(), ...fields };
  localStorage.setItem(draftKey(userId), JSON.stringify(draft));
  return draft;
}

export function clearDraft(userId) {
  try {
    localStorage.removeItem(draftKey(userId));
  } catch {
    // Storage unavailable; nothing to clear.
  }
}
